export default __webpack_public_path__ + "static/banner-everything-you-need-to-know-about-personal-loans-bd88768e9dc1600b549edf8519682ba4.jpg";